module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.name
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19839e7f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19839e7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/carehome/details/carehome-detail.scp.html
// module id = 453
// module chunks = 0